import { ApiClientError } from '@raydiant/api-client-js';
import { useQueryClient } from 'react-query';
import raydiant from '../clients/raydiant';
import { keys } from '../queryClient';
import useProtectedMutation from './useProtectedMutation';

export default function useDeleteContent() {
  const queryClient = useQueryClient();

  const mutation = useProtectedMutation<
    string | void,
    ApiClientError,
    { id: string; resourceType: string }
  >(
    async ({ id, resourceType }) => {
      switch (resourceType) {
        case 'folder':
          return await raydiant.deleteFolder(id);
        case 'presentation':
          return await raydiant.deletePresentation(id);
        case 'playlist':
          return await raydiant.deletePlaylist(id);
        default:
          throw new Error(`Unknown resource type: ${resourceType}`);
      }
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(keys.library());
      },
    },
  );

  return mutation;
}
